
import { defineComponent } from 'vue';
import SideAvatar from '@/components/SideAvatar.vue';
import SearchInput from './SearchInput.vue';

export default defineComponent({
  components: {
    SideAvatar,
    SearchInput,
  },
  props: {
    /** 是否显示返回按钮 */
    isBackVisible: { type: Boolean, default: false },
    /** 搜索是否禁用 */
    searchDisabled: { type: Boolean, default: false },
  },
  emits: ['click-back'],
  methods: {
    handleClickBack() {
      this.$emit('click-back');
    },
  },
});
